import moment from "../../moment";

export const checkIsValidDate = (started_at, limited_at, selectedDate) => {
  // 販売開始日 当日は購入可能にするため、-1日
  var start = getStartDate(started_at).subtract(1, "d");
  // 販売終了日
  var limit = moment(new Date(limited_at));

  // 日付選択で指定されている日付
  var selected = moment(new Date(selectedDate)).subtract(9, "h");

  console.log("selected :>> ", selected);
  console.log("limit :>> ", limit);
  console.log("start :>> ", start);

  // 指定されてい日付がlimitより前かつ、startより後ろであればtrue
  return (
    (selected.isBefore(limit) ? true : false) &&
    (selected.isAfter(start) ? true : false)
  );
};

// 現在時刻と比較して、現在時刻が発売前なら発売開始日を返す(MJの値を引数に渡す)
const getStartDate = (started_at) => {
  var start = moment(new Date(started_at));
  var current_time = moment(new Date());

  return current_time.isBefore(start) ? start : current_time;
};
